import { render, staticRenderFns } from "./PublishTitle.vue?vue&type=template&id=ce12d922&scoped=true"
import script from "./PublishTitle.vue?vue&type=script&lang=js"
export * from "./PublishTitle.vue?vue&type=script&lang=js"
import style0 from "./PublishTitle.vue?vue&type=style&index=0&id=ce12d922&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce12d922",
  null
  
)

export default component.exports